import { useCallback, useEffect, useMemo, useState } from 'react';

import useWindowDimensions from './useWindowDimensions';

/** Вычисляет доступную высоту (до viewport bottom)
 *  для элемента передаваемого как ref
 */
export default function useAvailableHeight(ref: any) {
  const [height, setHeight] = useState(0);
  const { windowHeight } = useWindowDimensions();

  const calcAvailableHeight = useCallback(() => {
    if (ref.current) {
      setHeight(windowHeight - Math.max(ref.current.getBoundingClientRect().top, 0));
    }
  }, [windowHeight, ref]);

  useEffect(() => {
    const debouncedListener = calcAvailableHeight as unknown as EventListener;

    calcAvailableHeight();

    window.addEventListener('scroll', debouncedListener);

    return () => window.removeEventListener('scroll', debouncedListener);
  }, [calcAvailableHeight, windowHeight]);

  return useMemo(
    () => ({
      height,
    }),
    [height],
  );
}
